



















import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import EventCard from './EventCard.vue';

@Component({
  components: {
    EventCard,
  },
})
export default class EventCardListComponent extends Vue {
  @Prop({ required: true })
  eventsUi!: Array<EventUI>;

  toggle(eventUI: EventUI, index: number): void {
    this.$emit('on-list-change', {
      eventUI: eventUI.toggle(),
      index,
    });
  }

  favorite(eventUI: EventUI) {
    this.$emit('on-favorite', eventUI);
  }

  get eventsUI(): Array<EventUI> {
    return this.eventsUi.map(({ event }) => new EventUI(event));
  }
}
